import { RootStateOrAny, useSelector } from 'react-redux';
import { LocationResource } from 'util/resources/Location';

export const useEmployerLocations = (): LocationResource[] =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  useSelector((state: RootStateOrAny) => state.employer.locations as LocationResource[]);
